<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <Loader v-if="!outputReady" />
        <div v-if="outputReady">
          <div>
            <div class="flex-row-sb col-4" style="padding-left:0px;">
              <div><h4 style="margin-bottom:20px;margin-top:20px;">Fragen & Antworten</h4></div>
              <div class="button-container" v-if="isAdmin">
                <b-button style="margin-right:5px;" size="s" @click="openNewCategoryModal">Kategorien</b-button>
                <b-button size="s" @click="openNewThemaModal">Themen</b-button>
              </div>
            </div>
          </div>
          <div class="faq-container card">
            <div v-for="(item, index) in questionsToCategories" :key="index + 'cat'">
              <div class="faq-category card-header" v-if="item.length">
                <div class="faq-head">
                  <h5 style="margin-bottom:20px">{{ index.charAt(0).toUpperCase() + index.slice(1) }}</h5>
                  <div>
                    <span>{{ getDescription(item) }}</span>
                  </div>
                </div>
                <div class="faq-items default-according style-1 faq-accordion" v-if="item.length">
                  <b-card no-body class="col-12" v-for="faq in item" :key="faq.id + 'faq'" role="tab">
                    <b-card-header header-tag="div" role="tab" class="accordion-header-with-icons">
                      <b-button v-b-toggle="'accordion-' + faq.id" variant="default">
                        <feather type="help-circle" size="20" class="infra-blue inline-block"></feather>
                        <h5 style="display:inline-block; margin-left:10px;vertical-align:top;">{{ faq.titel }}</h5></b-button
                      >
                    </b-card-header>
                    <b-collapse :id="'accordion-' + faq.id" accordion="faq_accordion" role="tabpanel">
                      <b-card-body>
                        <h6>{{ faq.frage }}</h6>
                        <b-card-text v-html="faq.antwort"></b-card-text>
                      </b-card-body>
                      <div class="icons-right">
                        <feather
                          type="edit-2"
                          :id="'tt_edit_acc' + faq.id"
                          class="pointer infra-blue"
                          v-if="isAdmin"
                          @click="openEditModal(faq)"
                        ></feather>
                        <b-tooltip :target="'tt_edit_acc' + faq.id" triggers="hover" placement="left">Thema bearbeiten</b-tooltip>
                        <feather
                          type="trash"
                          :id="'tt_delete_acc' + faq.id"
                          class="pointer infra-blue"
                          v-if="isAdmin"
                          @click="openDeleteModal(faq)"
                        ></feather>
                        <b-tooltip :target="'tt_delete_acc' + faq.id" triggers="hover" placement="left">Thema löschen</b-tooltip>
                      </div>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
          <b-modal
            id="deleteTopicModal"
            size="md"
            @ok="deleteTopic"
            @hide="resetModalState('deleteTopicModal')"
            @cancel="closeModal('deleteTopicModal')"
          >
            <div class="container-fluid">
              "{{ modal.delete.titel }}"<br />
              Möchten Sie dieses Thema wirklich löschen ?
            </div>
            <template slot="modal-header">
              <h4>Thema löschen ?</h4>
            </template>
            <template slot="modal-ok">
              Löschen
            </template>
            <template slot="modal-cancel">
              Abbrechen
            </template>
          </b-modal>
          <b-modal id="editTopicModal" size="lg" @ok="editTopic" @hide="resetModalState('editTopicModal')" @cancel="closeModal('editTopicModal')">
            <div class="container-fluid">
              <div class="form-container">
                <label>Titel</label>
                <b-input-group class="form-input-group" prepend="Abc">
                  <b-input v-model="modal.edit.titel"></b-input>
                </b-input-group>
                <label>Frage</label>
                <b-input-group style="margin-bottom:10px;">
                  <b-input rows="10" v-model="modal.edit.frage"></b-input>
                </b-input-group>
                <label>Antwort</label>
                <vue-editor v-model="modal.edit.antwort" :editorToolbar="editorOptions"></vue-editor>
              </div>
            </div>
            <template slot="modal-header">
              <h4>Thema editieren für Kategorie {{ getCatName(this.modal.edit.kategorie) }}</h4>
            </template>
            <template slot="modal-ok">
              Speichern
            </template>
            <template slot="modal-cancel">
              Abbrechen
            </template>
          </b-modal>
          <b-modal
            id="createTopicModal"
            size="lg"
            @ok="createNewTopic"
            @hide="resetModalState('createTopicModal')"
            @cancel="closeModal('createTopicModal')"
          >
            <div class="container-fluid">
              <div class="form-container">
                <label>Titel</label>
                <b-input-group class="form-input-group" prepend="Abc">
                  <b-input v-model="modal.create.titel"></b-input>
                </b-input-group>
                <label>Frage</label>
                <b-input-group style="margin-bottom:10px;">
                  <b-input rows="10" v-model="modal.create.frage"></b-input>
                </b-input-group>
                <label>Antwort</label>
                <vue-editor v-model="modal.create.antwort" :editorToolbar="editorOptions"></vue-editor>
              </div>
            </div>
            <template slot="modal-header">
              <h4>Neues Thema erstellen für Kategorie {{ getCatName(this.modal.create.kategorie) }}</h4>
            </template>
            <template slot="modal-ok">
              Erstellen
            </template>
            <template slot="modal-cancel">
              Abbrechen
            </template>
          </b-modal>
          <div class="card col-4" v-if="displayEmptyMessage">
            <div class="card-body">
              <div class="empty-questions-message text-center">
                <h5>Keine Hilfethemen erstellt.</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- createNewCat Modal -->
    <b-modal id="kb_newCatModal" ok-only @hide="rstNewCatModal" size="md">
      <div>
        <b-tabs v-model="tbl_tabs.categories">
          <b-tab title="Kategorien">
            <b-col md="12" class="list_mode iam-table-ux" style="margin-top:20px;margin-left:0px;padding-left:0px;">
              <b-input-group class="datatable-btn">
                <div class="input-group">
                  <b-form-input style="border:1px solid lightgrey" v-model="tbl_filter.categories" placeholder="Suchen"></b-form-input>
                </div>
              </b-input-group>
            </b-col>
            <div class="table-responsive datatable-vue">
              <b-table
                show-empty
                :items="categories"
                :filtered="onFilteredCategories"
                :current-page="tbl_currentPage.categories"
                :filter="tbl_filter.categories"
                :per-page="tbl_perPage.categories"
                :fields="tbl_fields.categories"
              >
                <template v-slot:cell(actions)="row">
                  <feather type="trash" :id="'kb_delete_cat' + row.item.id" class="infra-blue pointer" @click="deleteCategory(row.item.id)"></feather>
                  <b-tooltip :target="'kb_delete_cat' + row.item.id" triggers="hover" placement="left">Kategorie entfernen</b-tooltip>
                </template>
                <template slot="empty"><div class="text-center">Keine Kategorien definiert.</div></template>
              </b-table>
            </div>
            <div class="pagination-container">
              <b-pagination
                v-if="tbl_totalRows.categories > tbl_perPage.categories"
                v-model="tbl_currentPage.categories"
                :total-rows="tbl_totalRows.categories"
                :per-page="tbl_perPage.categories"
                class="my-0"
              ></b-pagination>
            </div>
          </b-tab>
          <b-tab title="Neu">
            <div class="form-container" style="margin-top:10px;">
              <label>Kategorie</label>&nbsp;
              <div class="red inline-block" v-if="hasError('kategorie_name')">
                - mindestens {{ validation.hilfe_kategorien.name.minlength }} Zeichen.
              </div>
              <b-input-group prepend="Abc" class="form-input-group">
                <b-form-input v-model="modal.newCategory.name"></b-form-input>
              </b-input-group>
              <label>Beschreibung</label>&nbsp;
              <b-input-group prepend="Abc" class="form-input-group">
                <b-textarea rows="3" v-model="modal.newCategory.beschreibung"></b-textarea>
              </b-input-group>
              <div class="flex-row-sb">
                <b-button @click="validateNewCategory">Kategorie erstellen</b-button>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <template slot="modal-header"><h4>Kategorien bearbeiten</h4></template>
      <template slot="modal-ok">Schließen</template>
    </b-modal>
    <!-- End createNewCat Modal -->
    <!-- createNewThema Modal -->
    <b-modal id="kb_newThemaModal" ok-only @hide="rstNewThemaModal" size="lg">
      <div>
        <b-tabs v-model="tbl_tabs.themen">
          <b-tab title="Themen">
            <b-col md="12" class="list_mode iam-table-ux" style="margin-top:20px;margin-left:0px;padding-left:0px;">
              <b-input-group class="datatable-btn">
                <div class="input-group">
                  <b-form-input style="border:1px solid lightgrey" v-model="tbl_filter.themen" placeholder="Suchen"></b-form-input>
                </div>
              </b-input-group>
            </b-col>
            <div class="table-responsive datatable-vue">
              <b-table
                show-empty
                :items="questions"
                :filtered="onFilteredThemen"
                :current-page="tbl_currentPage.themen"
                :filter="tbl_filter.themen"
                :per-page="tbl_perPage.themen"
                :fields="tbl_fields.themen"
              >
                <template v-slot:cell(actions)="row">
                  <feather type="trash" :id="'kb_delete_thema' + row.item.id" class="infra-blue pointer" @click="deleteTopic(row.item.id)"></feather>
                  <b-tooltip :target="'kb_delete_thema' + row.item.id" triggers="hover" placement="left">Kategorie entfernen</b-tooltip>
                </template>
                <template slot="empty"><div class="text-center">Keine FAQ's definiert.</div></template>
              </b-table>
            </div>
            <div class="pagination-container">
              <b-pagination
                v-if="tbl_totalRows.themen > tbl_perPage.themen"
                v-model="tbl_currentPage.themen"
                :total-rows="tbl_totalRows.themen"
                :per-page="tbl_perPage.themen"
                class="my-0"
              ></b-pagination>
            </div>
          </b-tab>
          <b-tab title="Neu">
            <div class="form-container" style="margin-top:10px;">
              <label>Titel</label>&nbsp;
              <div class="red inline-block" v-if="hasError('thema_titel')">- mindestens {{ validation.hilfe_themen.titel.minlength }} Zeichen.</div>
              <b-input-group prepend="Abc" class="form-input-group">
                <b-form-input v-model="modal.newThema.titel" v-bind:class="{ form_error: hasError('thema_titel') }"></b-form-input>
              </b-input-group>
              <label>Frage</label>&nbsp;
              <div class="red inline-block" v-if="hasError('thema_frage')">- mindestens {{ validation.hilfe_themen.frage.minlength }} Zeichen.</div>
              <b-input-group prepend="Abc" class="form-input-group">
                <b-form-input v-model="modal.newThema.frage" v-bind:class="{ form_error: hasError('thema_frage') }"></b-form-input>
              </b-input-group>
              <label>Antwort</label>&nbsp;
              <div class="red inline-block" v-if="hasError('thema_antwort')">
                - mindestens {{ validation.hilfe_themen.antwort.minlength }} Zeichen.
              </div>
              <vue-editor
                v-model="modal.newThema.antwort"
                :editorToolbar="editorOptions"
                v-bind:class="{ form_error: hasError('thema_antwort') }"
                style="margin-bottom:20px;"
              ></vue-editor>
              <label>Kategorie</label>
              <b-input-group class="form-input-group">
                <b-form-select
                  v-model="modal.newThema.kategorie"
                  :options="kategorie_options"
                  name="category"
                  v-bind:class="{ form_error: hasError('thema_kategorie') }"
                ></b-form-select>
              </b-input-group>
              <div class="flex-row-sb">
                <b-button class="btn btn-primary" @click="validateNewThema">FAQ erstellen</b-button>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <template slot="modal-header">Themen bearbeiten</template>
    </b-modal>
    <!-- End createNewThema Modal -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader.vue";
import { VueEditor } from "vue2-editor";

export default {
  name: "AdminHilfe",
  components: {
    Loader: Loader,
    VueEditor: VueEditor,
  },
  data() {
    return {
      modal: {
        create: {},
        edit: {},
        delete: {},
        newCategory: {
          name: "",
          beschreibung: "",
        },
        newThema: {
          titel: "",
          frage: "",
          antwort: "",
          kategorie: "default",
        },
      },
      questionsToCategories: {},
      outputReady: false,
      updating: {
        create: false,
        edit: false,
        delete: false,
      },
      displayEmptyMessage: false,
      tbl_fields: {
        categories: [
          { key: "name", label: "Kategorie", sortable: true },
          { key: "actions", label: "Aktionen", sortable: false },
        ],
        themen: [
          { key: "titel", label: "Titel", sortable: true },
          { key: "frage", label: "Frage", sortable: true },
          { key: "actions", label: "Aktionen", sortable: true },
        ],
      },
      tbl_currentPage: {
        categories: 1,
        themen: 1,
      },
      tbl_filter: {
        categories: null,
        themen: null,
      },
      tbl_perPage: {
        categories: 10,
        themen: 10,
      },
      tbl_totalRows: {
        categories: 1,
        themen: 1,
      },
      tbl_tabs: {
        categories: 0,
        themen: 0,
      },
      validation_errors: [],
    };
  },
  computed: {
    ...mapGetters({
      questions: "kb/all",
      categories: "kb/categories",
      isAdmin: "auth/isAdmin",
      ready: "kb/readyState",
      toasts: "app/toasts",
      questionsUpdating: "kb/updateState",
      animations: "app/animations",
      validation: "app/validation",
      editorOptions: "app/editorOptions",
    }),
    kategorie_options() {
      let options = this.categories.map((c) => {
        return { value: c.id, text: c.name };
      });
      options.unshift({ value: "default", text: "Bitte wählen", disabled: true });
      return options;
    },
  },
  async created() {
    if (!this.ready) {
      try {
        await this.$store.dispatch("kb/init");
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden der Daten.", this.toasts.failure);
      }
    }
    this.buildQuestionsToCategories();
  },
  methods: {
    async validateNewCategory() {
      this.validation_errors = [];
      const toValidate = this.modal.newCategory.name;
      try {
        const validationPayload = {
          context: "hilfe_kategorien",
          field: "name",
          value: toValidate,
        };
        const response = await this.$store.dispatch("app/validateField", validationPayload);
        if (!response) this.validation_errors.push("kategorie_name");
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }

      if (this.validation_errors.length) return;

      const createPayload = {
        name: toValidate,
        beschreibung: this.modal.newCategory.beschreibung,
      };

      await this.createNewCategory(createPayload);
      await this.$store.dispatch("kb/getCategories");
      this.rstNewCatModal();
      this.tbl_tabs.categories = 0;
    },
    async validateNewThema() {
      this.validation_errors = [];
      const fields = ["titel", "frage", "antwort"];
      await Promise.all(
        fields.map(async (field) => {
          const result = await this.$store.dispatch("app/validateField", {
            context: "hilfe_themen",
            field,
            value: this.modal.newThema[field],
          });
          if (!result) this.validation_errors.push("thema_" + field);
        })
      );
      if (this.modal.newThema.kategorie == "default") this.validation_errors.push("thema_kategorie");
      if (this.validation_errors.length) return;

      await this.createNewTopic("two");
    },
    async createNewCategory(payload) {
      try {
        await this.$store.dispatch("kb/createNewCategory", payload);
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    async deleteCategory(catId) {
      try {
        await this.$store.dispatch("kb/deleteCategory", catId);
        await this.$store.dispatch("kb/getCategories");
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    onFilteredCategories(filteredItems) {
      this.tbl_totalRows.categories = filteredItems.length;
      this.tbl_currentPage.categories = 1;
    },
    onFilteredThemen(filteredItems) {
      this.tbl_totalRows.themen = filteredItems.length;
      this.tbl_currentPage.themen = 1;
    },
    openEditModal(topic) {
      this.modal.edit = topic;
      this.$bvModal.show("editTopicModal");
    },
    openDeleteModal(topic) {
      this.modal.delete = topic;
      this.$bvModal.show("deleteTopicModal");
    },
    openModal(modal, data = null) {
      this.modal.create.kategorie = this.categories.find((c) => c.name == this.ucFirst(data)).id;
      this.$bvModal.show(modal);
    },
    closeModal(modal) {
      this.$bvModal.hide(modal);
    },
    openNewCategoryModal() {
      this.$bvModal.show("kb_newCatModal");
    },
    openNewThemaModal() {
      this.$bvModal.show("kb_newThemaModal");
    },
    rstNewCatModal() {
      this.validation_errors = [];
      this.modal.newCategory = { name: "" };
    },
    rstNewThemaModal() {
      this.validation_errors = [];
      this.tbl_tabs.themen = 0;
      this.modal.newThema = { titel: "", frage: "", antwort: "", kategorie: "default" };
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    resetModalState(modal) {
      switch (modal) {
        case "createTopicModal":
          this.modal.create = {};
          break;
        case "editTopicModal":
          this.modal.edit = {};
          break;
        case "deleteTopicModal":
          this.modal.delete = {};
          break;
      }
    },
    async createNewTopic(mode = "one") {
      const values = mode == "one" ? this.modal.create : this.modal.newThema;
      try {
        this.updating.create = true;
        await this.$store.dispatch("kb/createNewTopic", values);
        await this.$store.dispatch("kb/getQuestions");
        this.buildQuestionsToCategories();
        if (mode == "one") this.closeModal("createTopicModal");
        if (mode == "two") this.$bvModal.hide("kb_newThemaModal");
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Erstellen der Frage.", this.toasts.failure);
      } finally {
        this.updating.create = false;
      }
    },
    async editTopic() {
      console.log(this.modal.edit);
      const payload = {
        collection: "kb",
        item: this.modal.edit.id,
        changes: {
          titel: this.modal.edit.titel,
          frage: this.modal.edit.frage,
          antwort: this.modal.edit.antwort,
        },
      };
      try {
        await this.$store.dispatch("app/mutate", payload);
        await this.$store.dispatch("kb/init");
        this.closeModal("editTopicModal");
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim aktualisieren der Daten.", this.toasts.failure);
      }
    },
    async deleteTopic(themaId = false) {
     
      const id = themaId ? themaId : this.modal.delete.id;
      const payload = {
        collection: "kb",
        items: [id],
      };
      try {
        await this.$store.dispatch("app/removeItems", payload);
        await this.$store.dispatch("kb/init");
        this.buildQuestionsToCategories();
        this.closeModal("deleteTopicModal");
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Löschen.", this.toasts.failure);
      }
    },
    async buildQuestionsToCategories() {
      console.log("running buildQuestionsToCategories");
      if (!this.questions.length || !this.categories.length) {
        this.outputReady = true;
        this.displayEmptyMessage = true;
        return;
      }
      if (!this.questions.length || !this.categories.length) return;
      this.outputReady = false;
      this.questionsToCategories = {};
      for (let idx = 0; idx < this.categories.length; idx++) {
        if (!this.questionsToCategories.hasOwnProperty(this.categories[idx].name.toLowerCase()))
          this.questionsToCategories[this.categories[idx].name.toLowerCase()] = [];
      }

      for (let idx = 0; idx < this.questions.length; idx++) {
        const category = this.categories.find((c) => c.id == this.questions[idx].kategorie);
        this.questionsToCategories[category.name.toLowerCase()].push(this.questions[idx]);
      }

      this.outputReady = true;
    },
    getCatName() {
      if (!this.modal.create.kategorie || !this.modal.edit.kategorie) return;
      return this.categories.find((c) => c.id == this.modal.create.kategorie).name;
    },
    getDescription(cat) {
      const found = this.categories.find((c) => c.id == cat[0].kategorie);
      if (found !== -1) return found.beschreibung;
    },
  },
};
</script>

<style scoped>
.faq-head {
  margin-bottom: 20px;
}

.accordion-header-with-icons {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding: 20px !important;
  padding-left: 0px !important;
}

.faq-items {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  align-items: flex-start;
}

.faq-items .card {
  margin-right: 10px;
}

.icons-right {
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: flex-end;
}

p.card-text ul {
  list-style-type: square !important;
}
</style>
